const filesRules = {
  extensions: ["image/jpeg", "image/jpg", "image/png", "application/pdf"],

  extensionsList: ["jpeg", "jpg", "png", "pdf"],

  maxSize: 1024 * 12,

  // Límite especial para el proceso de registro (64 MB)
  registrationMaxSize: 1024 * 64,
};

export default filesRules;
